import _ from "lodash";
import * as DateUtils from "../../../../../utils/date/date";

export class CalcOperation {
    /**
     * @public
     * Regras para series contates como MES, TOTAL, QUANTIDADE
     * @param
     */
    static isConstant = (variable, time, points = []) => {
        const currentPointMonth = parseInt(DateUtils.dateToString(time, "M"));

        const constantLiteral = {
            MES: () => currentPointMonth,
            QUANTIDADE: () => {
                if (!points.length) return currentPointMonth;

                const firstGivenPoints = _.head(
                    points
                        .filter(
                            (p) =>
                                DateUtils.getFullYear(p.t) ===
                                DateUtils.getFullYear(time)
                        )
                        .sort((a, b) => a.t > b.t)
                );

                return (
                    currentPointMonth -
                    parseInt(DateUtils.dateToString(firstGivenPoints, "M"))
                );
            },
            default: () => {
                return 0;
            }
        };

        const handler = {
            get: (target, name) => {
                return target.hasOwnProperty(name)
                    ? target[name]
                    : target["default"];
            }
        };

        const constantProxy = new Proxy(constantLiteral, handler);

        return constantProxy[variable]();
    };

    static moviment(x, y) {
        y = y || 0;

        // if (x <= 0 && y <= 0) return (x - y) * -1;

        return x - y;
    }

    /**
     * Method that adds months to a date
     * @param Date t date
     * @param Number months numbe of months to add
     */
    static helperMonths = (t, months) => {
        const startOfMonth = DateUtils.getStartOfMonth(t);
        const dateWithAddedMonths = DateUtils.addToDate(
            startOfMonth,
            months,
            "months"
        );
        return DateUtils.dateToISOString(dateWithAddedMonths);
    };
}
